import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

/**
 * Pail-shaped icon for an emotion bucket. It uses the MUI SvgIcon contract so
 * sizing, colour, accessibility, and theming remain consistent with Studio.
 */
const EmotionBucketIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 8.5h12l-1.15 9.42A2.35 2.35 0 0 1 14.52 20H9.48a2.35 2.35 0 0 1-2.33-2.08L6 8.5Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 8.5V7.25a3.75 3.75 0 0 1 7.5 0V8.5M5 8.5h14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </SvgIcon>
))

EmotionBucketIcon.displayName = 'EmotionBucketIcon'

export default EmotionBucketIcon
